// extracted by mini-css-extract-plugin
export var arrow = "bk_9";
export var body = "bk_g";
export var circle = "bk_d1";
export var customer = "bk_d0";
export var feedback = "bk_dZ";
export var feedbacks = "bk_dX";
export var footer = "bk_cS";
export var footerText = "bk_cT";
export var left = "bk_bL";
export var nameLocation = "bk_d2";
export var padding = "bk_dN";
export var right = "bk_bQ";
export var section = "bk_j";
export var selected = "bk_bg";
export var selectors = "bk_dW";
export var subtitle = "bk_cq";
export var text = "bk_cl";
export var title = "bk_d";
export var wrapper = "bk_dY";